import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Hero.css';

class Hero extends Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.content}>
            <h1 className={s.title}>
              {'Så använder du inspirerande och korrekta kostråd'}
            </h1>
            <p className={s.lead}>
              {`En guide om hur du använder Livsmedelsverkets
                kostråd i märkning och marknadsföring`}
            </p>
          </div>
        </div>
        <div className={s.tint} />
      </div>
    );
  }
}

export default withStyles(s)(Hero);



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js